import { INotification, NotificationType } from '@common/stores';
import classNames from 'classnames';
import React, { useState } from 'react';
import { Toast } from 'react-bootstrap';

interface IProps {
    onClose: () => void,
    notification: INotification
}

export const NotificationToast = ({ notification: { message, type }, onClose }: IProps) => {
    const [show, setShow] = useState(true);
    const close = () => {
        setShow(false);
        onClose();
    }
    const symbol = type === NotificationType.SUCCESS ? "fa-check" : "fa-exclamation-triangle";
    const duration = type === NotificationType.SUCCESS ? 2500 : 10000;
    const bg = type.toLowerCase();
    return (
        <Toast show={show} onClose={close} autohide animation delay={duration} bg={bg}>
            <Toast.Header>
                <strong className="me-auto">
                    <i className={classNames("fa", symbol)}></i>
                    <span style={{ marginLeft: "0.5rem", whiteSpace: "pre-line" }}>{
                        (typeof message === 'object') ? JSON.stringify(message) : message
                    }</span>
                </strong>
            </Toast.Header>
            {/* Toast.Body intentionally left off because there's just not that much to say... */}
        </Toast>
    )
};
